module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_5010.b9cbaaf0.png";